import React from "react";
import { useEffect } from "react";
import Header from "@/components/Header";
import Footer from "@/components/Footer";

import Image from "next/image";
import Link from "next/link";
import AOS from "aos";

import Pro14 from "@/public/static/images/project_14.jpg";
import Pro15 from "@/public/static/images/project_15.png";

function ai_translation() {
  return (
    <div className="wrapper">
      <Header />
      <section className="proj">
        <div className="container">
          <div className="row">
            <div className="col-12 project_box">
              <div className="row">
                <div className="col-12 col-md-7 order-md-1 order-2">
                  <div>
                    <div className="project-heading">
                      <h1 className="t-green">AI Translation</h1>
                    </div>
                  </div>
                  {/* <div  className="badge_box">
                    <Link href="/ourservice/localization">
                      <span className="badge rounded-pill text-bg-light">
                        Localization
                      </span>
                    </Link>
                    <Link href="/ourservice/localization">
                      <span className="badge rounded-pill text-bg-light">
                        Translation
                      </span>
                    </Link>
                  </div> */}
                  <div className="project_content-inner project-list">
                    <p>
                      With our expertise and core focus on translation services,
                      <br />
                      we take pride in our ability to provide translations in up
                      <br />
                      to 60 languages through our global network.{" "}
                    </p>
                  </div>
                </div>
                <div className="col-12 col-md-5 order-md-2 order-1">
                  <Image
                    loading="lazy"
                    src={Pro14}
                    alt="AI Translation"
                    className="img-fluid mx-auto "
                  />
                </div>
              </div>
            </div>

            <div className="col-12 project_content">
              <div className="row mb-5">
                <div className="col-12 col-md-6 mb-3 project_content-inner order-md-1 order-2">
                  <Image
                    loading="lazy"
                    src={Pro15}
                    alt="AI Translation"
                    className="img-fluid px-5 mb-3"
                  />
                </div>

                <div className="col-12 col-md-6 mb-3 project_content-inner order-md-2 order-1">
                  <div className="project_content-inner mb-5">
                    <h2 className="t-green mb-2">Function</h2>
                    <p>
                      - Hybrid translation "AI x HUMAN"
                      <br />
                      - for automotive field
                      <br />
                      - English to Thai
                      <br />- English to Taiwanese
                    </p>
                  </div>

                  <div className="project_content-inner mb-5">
                    <h2 className="t-green mb-2">Background</h2>
                    <p className="mb-3">
                      1. Difficult to perform big volume translation and
                      proofrreading in short leadtime required by client.
                      <br />
                      2. Hard to meet client's requirement of cost reduction
                    </p>
                  </div>

                  <div className="project_content-inner mb-5">
                    <h2 className="t-green mb-2">Result</h2>
                    <p className="mb-3">
                      1. Achieve cost down more than 30%.
                      <br />
                      2. Perform task with shorter translation leadtime.
                      <br />
                      3. Be able to focus more on quality control.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}

export default ai_translation;
